module.exports = __webpack_public_path__ + "static/media/IMG-20220912-WA0003 - Matthew Moore.c420068b.jpg";